import React from 'react';
import Link from 'next/link';

export default function BiharFooter() {
  return (
    <footer className="bg-zinc-900 text-white py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
          <div className="text-zinc-400 text-sm">
            <p>&copy; {new Date().getFullYear()} Bihar Tools & Services. All rights reserved.</p>
          </div>
          
          <div className="flex space-x-6 text-sm">
            <Link href="/bihar/privacy-policy" className="text-zinc-300 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link href="/bihar/terms-of-service" className="text-zinc-300 hover:text-white transition-colors">
              Terms of Service
            </Link>
            <Link href="/bihar/refund-policy" className="text-zinc-300 hover:text-white transition-colors">
              Refund Policy
            </Link>
            <Link href="/bihar/shipping-policy" className="text-zinc-300 hover:text-white transition-colors">
              Shipping Policy
            </Link>
            <Link href="/bihar/pricing" className="text-zinc-300 hover:text-white transition-colors">
              Pricing
            </Link>
          </div>
        </div>
        <div className="text-center text-zinc-500 text-xs mt-4 pt-4 border-t border-zinc-800">
          <p>
            This is an independent, third-party service and is not affiliated with any government entity.
          </p>
        </div>
      </div>
    </footer>
  );
} 